// import React, { useState } from "react";
// import api from "../../api/axios";
// import { useNavigate } from "react-router-dom";

// const AdminHeader = ({  user, onLogout }) => {
//   const [open, setOpen] = useState(false);
//   const navigate = useNavigate();

//   const handleLogout = async () => {
//   try {
//     await api.post(
//       "admin/logout/",
//       {},
//       { withCredentials: true }
//     );
//   } catch (err) {
//     // even if logout fails, force redirect
//     console.error("Logout error", err);
//   } finally {
//     localStorage.removeItem("user"); // UI cache only
//     navigate("/admin_login", { replace: true });
//   }
// };
//   return (
//     <div style={styles.header}>
//       {/* Left section */}
//       <div style={styles.left}>

//         <a href="/" style={styles.visitLink}>
//           Visit Website
//         </a>
//       </div>

//       {/* Right section */}
//       <div style={styles.right}>
//         <button style={styles.actionBtn}onClick={() => navigate("/admin/maintenance/create")}>Create a Service Tag</button>
//         <span style={styles.fullscreen}>⤢</span>

//           {/* User box with dropdown */}
//         <div style={styles.userWrapper} onMouseEnter={() => setOpen(true)}
//           onMouseLeave={() => setOpen(false)}>
//           <div style={styles.userBox}>
//             <div style={styles.avatar}>👤</div>
//             <span style={styles.username}>
//               {user?.username || "Admin"}
//             </span>
//           </div>

//           {open && (
//             <div style={styles.dropdown}>
//               <div style={styles.dropdownUser}>
//                 {user?.username || "Admin"}
//               </div>
//               <div style={styles.divider} />
//               <button
//                 style={styles.logoutBtn}
//                 onClick={handleLogout}
//               >
//                 Logout
//               </button>
//               </div>
//               )}
//             </div>
//       </div>
//       </div>
//   );
// };
// const styles = {
//   header: {
//     height: "64px",
//     backgroundColor: "#ffffff",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     padding: "0 20px",
//     borderBottom: "1px solid #e5e7eb",
//   },

//   left: {
//     display: "flex",
//     alignItems: "center",
//     gap: "15px",
//   },

//   menuIcon: {
//     fontSize: "22px",
//     cursor: "pointer",
//   },

//   visitLink: {
//     color: "#2563eb",
//     fontWeight: "500",
//     textDecoration: "none",
//   },

//   right: {
//     display: "flex",
//     alignItems: "center",
//     gap: "18px",
//   },

//   actionBtn: {
//     backgroundColor: "#14b8a6",
//     color: "#fff",
//     border: "none",
//     padding: "10px 16px",
//     borderRadius: "6px",
//     cursor: "pointer",
//     fontSize: "14px",
//   },

//   fullscreen: {
//     fontSize: "18px",
//     cursor: "pointer",
//   },

//   userBox: {
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//   },

//   avatar: {
//     width: "32px",
//     height: "32px",
//     borderRadius: "50%",
//     backgroundColor: "#e5e7eb",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "16px",
//   },

//   username: {
//     fontWeight: "500",
//   },
//   dropdown: {
//     position: "absolute",
//     top: "42px",
//     right: 0,
//     width: "160px",
//     backgroundColor: "#fff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "6px",
//     boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
//     zIndex: 1000,
//   },

//   dropdownUser: {
//     padding: "10px 12px",
//     fontWeight: "500",
//     fontSize: "14px",
//   },

//   divider: {
//     height: "1px",
//     backgroundColor: "#e5e7eb",
//   },

//   logoutBtn: {
//     width: "100%",
//     background: "none",
//     border: "none",
//     padding: "10px 12px",
//     textAlign: "left",
//     cursor: "pointer",
//     color: "#dc2626",
//     fontWeight: "500",
//   },
// };
// export default AdminHeader;
import React, { useState } from "react";
import api from "../../api/axios";
import { useNavigate } from "react-router-dom";
import ServiceTagModal from "./ServiceTagModal";

const AdminHeader = ({ user }) => {
  const [open, setOpen] = useState(false);
  const [showServiceTag, setShowServiceTag] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");
  localStorage.removeItem("user");
  sessionStorage.clear();
  navigate("/admin_login", { replace: true });
};



  return (
    <>
      <div style={styles.header}>
        <div style={styles.left}>
          <a href="/" style={styles.visitLink}>Visit Website</a>
        </div>

        <div style={styles.right}>
          <button
            style={styles.actionBtn}
            onClick={() => setShowServiceTag(true)}
          >
            Create a Service Tag
          </button>

          <span style={styles.fullscreen}>⤢</span>

          <div
            style={styles.userWrapper}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
          >
            <div style={styles.userBox}>
              <div style={styles.avatar}>👤</div>
              <span style={styles.username}>
                {user?.username || "Admin"}
              </span>
            </div>

            {open && (
              <div style={styles.dropdown}>
                <div style={styles.dropdownUser}>
                  {user?.username || "Admin"}
                </div>
                <div style={styles.divider} />
                <button
                  style={styles.logoutBtn}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ✅ MODAL */}
      {showServiceTag && (
        <ServiceTagModal onClose={() => setShowServiceTag(false)} />
      )}
    </>
  );
};

const styles = {
  header: {
    height: "64px",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 20px",
    borderBottom: "1px solid #e5e7eb",
  },

  left: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },

  menuIcon: {
    fontSize: "22px",
    cursor: "pointer",
  },

  visitLink: {
    color: "#2563eb",
    fontWeight: "500",
    textDecoration: "none",
  },

  right: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
  },

  actionBtn: {
    backgroundColor: "#14b8a6",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
  },

  fullscreen: {
    fontSize: "18px",
    cursor: "pointer",
  },

  userBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },

  avatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: "#e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
  },

  username: {
    fontWeight: "500",
  },
  dropdown: {
    position: "absolute",
    top: "42px",
    right: 0,
    width: "160px",
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    zIndex: 1000,
  },

  dropdownUser: {
    padding: "10px 12px",
    fontWeight: "500",
    fontSize: "14px",
  },

  divider: {
    height: "1px",
    backgroundColor: "#e5e7eb",
  },

  logoutBtn: {
    width: "100%",
    background: "none",
    border: "none",
    padding: "10px 12px",
    textAlign: "left",
    cursor: "pointer",
    color: "#dc2626",
    fontWeight: "500",
  },
};
export default AdminHeader;

